<template>
  <h1 class="main-title">
    <slot></slot>
  </h1>
</template>

<script>
export default {};
</script>

<style scoped>
.main-title {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  color: var(--black-color);
  margin-bottom: 0;
}
</style>
